import React from "react";
import "./Header.css";

export default function Header() {
  return (
      <header>
        <div className="header-logo-container">
          <a href="/home">  
            <div className="logo-container"> 
                <img alt="Sertify Account" src="https://sert-consumer.s3.amazonaws.com/images/logos/Sertify_logoart_black_whitedoor_RGB.png"/>
            </div>
          </a>
        </div>
      </header>

  );
}